/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Participatedulworkshopmotivation4Inputs */

const de__field_participatedulworkshopmotivation4 = /** @type {(inputs: _Field_Participatedulworkshopmotivation4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilgenommen an ÜL-Workshop Motivation`)
};

/**

* @param {_Field_Participatedulworkshopmotivation4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_participatedulworkshopmotivation4 = /** @type {((inputs?: _Field_Participatedulworkshopmotivation4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Participatedulworkshopmotivation4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_participatedulworkshopmotivation4(inputs)
});
export { _field_participatedulworkshopmotivation4 as "_field_participatedULWorkshopMotivation" }